import './rubleIcons.scss'
import clsx from 'clsx'
import { RubleIcon, GreyRubleIcon } from '@/shared/assets'

interface RubleIconProps {
    className?: string
}

export const RubleIconInline = ({ className }: RubleIconProps) => (
    <img
        src={RubleIcon}
        alt="₽"
        className={clsx('inline-rub-icon', className)}
    />
)

export const GreyRubleIconInline = ({ className }: RubleIconProps) => (
    <img
        src={GreyRubleIcon}
        alt="₽"
        className={clsx('inline-grey-rub-icon', className)}
    />
)
